"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _webexCore = require("@webex/webex-core");
var _constants = require("../constants");
/*!
 * Copyright (c) 2015-2023 Cisco Systems, Inc. See LICENSE file.
 */

var SILanguage = _webexCore.WebexPlugin.extend({
  idAttribute: 'languageName',
  namespace: _constants.MEETINGS,
  props: {
    languageCode: 'number',
    languageName: 'string'
  },
  version: "3.7.0-web-workers-keepalive.1"
});
var _default = exports.default = SILanguage;
//# sourceMappingURL=siLanguage.js.map
